// extracted by mini-css-extract-plugin
export default {"dash_page":"signs_dash_page__t7Vw2","Container":"signs_Container__P54sC","org":"signs_org__EnOBv"};